package org.mkui.component

import react.FC

actual open class CPComponentWrapper actual constructor(val component: CPComponent) : CPComponent {
    override val nativeComponent: FC<*>
        get() = component.nativeComponent
}